import Challenges from './screen';
import { connect } from 'react-redux';

import { fetchChallengeAcceptList, fetchChallengeHistoryList } from '../../../../redux/actions';

const mapStateToProps = (state) => {
  return {
    state,
    userId: state.CommonReducer.userId,
    sessionToken: state.CommonReducer.sessionToken,
    loading: state.LoadingReducer.isLoading,
    challengeAcceptList: state.ChallengeReducer.challengeAcceptList,
    challengeHistoryList: state.ChallengeReducer.challengeHistoryList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchChallengeAcceptList: (params, callback) =>
      dispatch(fetchChallengeAcceptList(params, callback)),

    fetchChallengeHistoryList: (params, callback) =>
      dispatch(fetchChallengeHistoryList(params, callback)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Challenges);
